export default {
  base: {
    search: "搜索",
    reset: "重置",
    operation: "操作",
    edit: "编辑",
    submit: "提交",
    back: "返回",
    cancle: "取消",
    sure: "确定",
    enter: "请输入",
    choice: "请选择",
    success: "成功",
    del: "确认删除?",
    delCon: "确认删除这条记录",
    delChannel: "确认删除这条渠道",
    updatedAt: "操作",
    beginDate: "开始时间",
    lbeginDate: "请选择开始时间",
    endDate: "结束时间",
    lendDate: "请选择结束时间",
    save: "保存",
    next: "下一步",
    status: "状态",
    detail: "详情",
    basicInFo: "基础信息",
    exportcreateInFo: "创建信息",
    createTime: "创建时间",
    createUser: "创建人",
    endTime: "到期时间",
    checkTime: "核销时间",
    ticketDetail: "票明细",
    exportExcel: "导出 Excel",
    qrCode: "二维码",
    seeQrCode: "查看二维码",
    shapeCode: "条形码",
    seeShapeCode: "查看条形码",
    move: "移除",
    name: "名称",
    time: "时间",
    week: "星期",
    ExportValidDetails: "导出有效票明细",
    ExportDelayDetails: "导出延期票明细",
    ExportscrapDetails: "导出作废票明细",
    import: "导入",
    litmitImg: "上传图片不超过",
    upload: "上传",
    pass: "通过",
    refuse: "拒绝",
    refusereason: "拒绝原因",
    yes: "是",
    no: "否",
    startUsing: "启用",
    forbidden: "禁用",
    export: "导出报表",
    report: "报表",
    notice: "注意",
    confirmverification: "确认核销",
    exportXml: "导出",
    export1: "导出 Past day Sales",
    export2: "导出 Daily Sales",
    export3: "导出 Daily Allotment",
    delete: "删除",
    createOrder: "下单",
    ticketKindDetail: "票种详情",
    count: "数量",
    print: "打印",
    download: "下载",
  },

  search: {
    name: "名称",
    status: "状态",
    code: "编码",
    enterName: "请填写名称",
    enterCode: "请填写编码",
    enterStatus: "请填写状态",
    venue: "场馆",
    enterVenue: "请填写场馆",
    performance: "演出",
    enterPerformance: "请填写演出",
    date: "日期",
    enterDate: "请选择日期",
    userId: "用户ID",
    tel: "手机号",
    enterUserId: "请填写用户ID",
    nickName: "昵称",
    enterTel: "请填写手机号",
    enternickName: "请填写昵称",
    orderID: "订单ID",
    enterOrderId: "请输入订单id",
    payStatus: "支付状态",
    enterPayStatus: "请选择支付状态",
    orderStatus: "订单状态",
    enterOrderStatus: "请选择订单状态",
    maNo: "票码",
    externalOrderId: "第三方订单ID",
    registeredTime: "注册时间",
    createOrderTime: "订单时间",
    statisticalTime: "统计时间",
  },

  tips: {
    totalSoldTicketCount: "时间范围内全部渠道的总已售票种数",
    totalSoldSeatCount: "时间范围内全部渠道的总已售座位数",
    totalTransCount: "时间范围内全部渠道的总已售订单数",
    totalSales: "时间范围内全部渠道的总已售金额",
    totalAllotment: "时间范围内的有效场次全部渠道的渠道库存数",
    totalSeatSoldPercent: "总已售座位数 / 总票量",
    transCount: "时间范围内当前渠道的交易订单数",
    transPercent: "交易订单数 / 时间范围内的总交易订单数",
    sales: "时间范围内当前渠道已售金额",
    allotment: "时间范围内有效场次当前渠道的渠道库存",
    soldTicketCount: "时间范围内当前渠道的已售票种数",
    soldSeatCount: "时间范围内当前渠道的已售座位数",
  },

  payTypeTips: {
    totalSales: "时间范围内的全部支付方式的总已售金额",
    sales: "时间范围内的当前支付方式的已售金额",
  },

  salesTips: {
    totalTicketCount: "时间范围内全部渠道的已售票种数",
    totalIssue: "时间范围内全部渠道的已售座位数",
    totalIssuePercent: "总已售座位数 /总票量",
    totalAvail: "总剩余可售座位数 /总票量",
    totalAvailPercent: "总剩余可售座位数 /总票量",
    totalSales: "时间范围内的全部渠道的已售金额",
  },

  ticketKindTips: {
    totalAllotment: "时间范围内的有效场次全部票种的票种库存数",
    totalTicketSold: "时间范围内全部票种的已售票种数",
    totalSeatSold: "时间范围内全部票种的已售座位数",
    totalTicketSales: "时间范围内的全部票种的已售金额",
    allotment: "时间范围内有效场次当前票种的票种库存",
    ticketSold: "时间范围内当前票种的已售票种数",
    seatSold: "时间范围内当前票种的已售座位数",
    ticketSales: "时间范围内当前票种的已售金额",
  },
  // 场馆
  Venues: {
    name: "名称",
    cg: "新建场馆",
    status: "状态",
    code: "编码",
    home: "首页",
    address: "地址",
    baidu: "百度位置",
    google: "谷歌位置",
    desc: "描述",
    longitude: "经度",
    latitude: "维度",
    Id: "场馆ID",
    contact: "联系方式",
    detailAd: "详细地址",
    venuesnew: "新增场馆",
    venuesedit: "编辑场馆",

    // 场馆提示语
    success: "成功",
    del: "确认删除",
    delCon: "确认删除该条记录",

    // input 内文字
    vName: "请输入场馆名称",
    vCode: "请输入场馆编码",
    vTel: "请输入联系方式",
    vLocation: "请选择场馆地址",
    vDeatilLocation: "请输入详细地址",
    vBaiDuLongitude: "百度经度",
    vBaiDuLatitude: "百度纬度",
    vGoogleLatitude: "谷歌纬度",
    vGoogleLongitude: "谷歌经度",
    vDescription: "请输入描述",
    vSel: "请选择状态",
  },

  // 演出

  Performance: {
    setting: "渠道保底配置",
    performance: "演出",
    lperformance: "请选择演出",
    formancedit: "演出编辑",
    rformancediticketKind: "演出票种",
    performancenew: "新增演出",
    performanceedit: "编辑演出",
    edit: "编辑",
    create: "创建演出",
    showtime: "场次",
    // table
    // add: 'Performance Add',
    sequenceNumber: "序号",
    performanceId: "演出ID",
    performanceCode: "编码",
    venueName: "场馆",
    performanceName: "演出名称",
    verticalImageUrl: "竖版海报",
    performanceBeginTime: "开始时间",
    performanceEndTime: "结束时间",
    performanceStatus: "状态",
    // end
    // tab change
    basic: "基本信息",
    ticketInfo: "售票须知",
    vieingInfo: " 观影须知",
    video: "视频",
    lightspot: "亮点",
    channel: "渠道",
    lchannel: "请选择渠道",
    // end
    lName: "演出名称 :",
    pName: "请输入演出名称",
    lCode: "演出编码 :",
    pCode: "请输入演出编码",
    lSequenceNumber: "序号 :",
    pSequenceNumber: "请输入序号",
    lVenuesId: "场馆ID",
    pVenuesId: "请选择场馆ID",
    lConfigId: "配置ID",
    pConfigId: "请选择配置ID",
    lPrice: "演出价格(元)",
    pPrice: "请输入演出价格",
    lTicketTotal: "总库存数",
    lLockTicketTotal: "锁定总库存数(张)",
    pTicketTotal: "请输入总库存数",
    lLockShareTicket: "锁定共享库存数(张)",
    lShareTicket: "共享库存数(张)",
    pShareTicket: "请输入共享库存数",
    lCrossPoster: "横版海报",
    pCrossPoster: "请上传横版海报",
    lPerticalPoster: "竖版海报",
    pVerticalPoster: "请上传竖版海报",
    detail: "项目详情",
    lTime: "演出时间",
    time: "请选择演出时间",
    status: "请选择演出状态",
    description: "描述",

    // video 内容
    addVideo: "新建视频",
    videoId: "演出视频ID",
    videoType: "视频类型",
    videoUrl: "视频URL",
    videoImg: "视频封面图",
    videoStatus: "视频状态",
    img: "图片",
    uploadVideo: "上传视频",
    posterImg: "封面图",
    pPoster: "请上传封面图",
    clientName: "视频名称",

    // lightSpot
    addLightSpot: "新建亮点",
    lightSpotId: "演出亮点ID",
    lightSpotTitle: "亮点标题",
    llightSpotTitle: "请输入亮点标题",
    lightSpotDes: "亮点描述",
    lightSpotStatus: "亮点状态",
    itemlightSpot: "项目亮点",

    // channel
    associatedChannel: "关联渠道",
    channelId: "渠道ID",
    channelName: "渠道名称",
    usedInventory: "渠道已用库存数",
    lockInventory: "渠道锁定库存数",
    ticketKind: "票种",
    lSticketKind: "请选择票种",

    // 票种
    addTicketKind: "添加票种",
    relatedTicket: "关联票种",
    ticketKindId: "票种ID",
    ticketKindName: "票种名称",
    ticketPrice: "票价(MOP)",
    lticketPrice: "请输入票价",
    maximumSingleTicket: "单人最大购买数(套)",
    lmaximumSingleTicket: "请输入单人最大购买数(套)",
    limitTotal: "是否限制总库存数",
    availableSeats: "占用座位数(个)",
    lavailableSeats: "请输入占用座位数(个)",
    lticketKind: "请输入票种名称",
    startWeek: "开始星期",
    lstartWeek: "请选择开始星期",
    endWeek: "结束星期",
    lendWeek: "请选择结束星期",
    nolimit: "不限制",
    limit: "限制",
    usedTicketKindInventory: "票种已用库存数",
    lockTicketKindInventory: "票种锁定库存数",

    // recommend
    addRecommend: "新增演出推荐",
    recommend: "推荐",
    recommendId: "推荐ID",
    ticket: "票号",
    showTimeId: "场次ID",

    redundantTicketCount: "冗余库存",
    performanceTime: "出售模式",

    parentChannelSetting: "父级渠道配置",
    useShareCount: "是否使用场次共享库存",
    parentChannelId: "父级渠道ID",
    totalCount: "渠道保底库存数(张)",
    parentShareCount: "渠道共享库存数(张)",
    channelSettlementPrice: "渠道结算价(RMB)",

    batchshowTime: "批量启用场次",
    batchgenerated: "批量生成场次",
    settingShow: "设置默认演出",
    cancelShow: "取消默认演出",
    exportXml: "导出有效票明细",
    exportTime: "场次时间范围",
  },

  // 渠道
  Channel: {
    channelName: "渠道名称",
    lchannelName: "请填写渠道名称",
    channelStatus: "渠道状态",
    lchannelStatus: "请选择渠道状态",
    createChannel: "新建渠道",
    total: "渠道数",
    code: "渠道编码",
    lcode: "请输入渠道编码",
    secret: "渠道秘钥",
    lsecret: "请输入渠道秘钥",
    recharge: "充值",
    companyInfo: "公司信息",
    financialInfo: "财务信息",
    contacts: "联系人",
    lcontacts: "请填写联系人",
    rechargeList: "充值列表",
    type: "渠道对接类型",
    ltype: "请选择渠道对接类型",
    company: "公司名称",
    lcompany: "请填写公司名称",
    dutyParagraph: "税号",
    ldutyParagraph: "请填写税号",
    location: "地址",
    llocation: "请填写地址",
    contactsTel: "公司联系方式",
    lcontactsTel: "请填写公司联系方式",
    serviceTel: "客服电话",
    lserviceTel: "请填写客服电话",
    bankName: "开户行",
    lbankName: "请填写开户行",
    accountNumber: "开户行账号",
    laccountNumber: "请填写开户行账号",
    totalPrice: "总充值金额(元)",
    ltotalPrice: "请填写总充值金额",
    usedPrice: "已使用金额(元)",
    lusedPrice: "请填写已使用金额",
    channelSettlementCycle: "渠道结算周期",
    lchannelSettlementCycle: "请选择渠道结算周期",
    channelDeposit: "渠道押金(元)",
    lchannelDeposit: "请输入渠道押金",
    refundDeposit: "退还押金(元)",
    lrefundDeposit: "请输入退还押金",
    addcontacts: "新增联系人",
    ID: "ID",
    position: "职位",
    lposition: "请输入职位",
    tel: "联系人电话",
    ltel: "请输入联系人电话",
    email: "邮箱",
    lemail: "请输入邮箱",
    comment: "备注",
    lcomment: "请输入备注",
    ldesc: "请输入描述",
    addRecharge: "新增充值",
    rechargeId: "渠道充值ID",
    rechargeVoucher: "充值凭证",
    rechargePrice: "充值金额(元)",
    lrechargePrice: "请填写充值金额",
    rechargePriceBefore: "充值前金额(元)",
    rechargePriceAfter: "充值后金额(元)",
    rechargeTime: "充值时间",
    auditStatus: "审核状态",
    audit: "审核",
    check: "查看",
    fillInfo: "请先补充财务信息",
    uploadRecharg: "上传凭证",
  },

  // 会员权益
  UserInfo: {
    add: "新增会员权益",
    discount: "折扣(%)",
    userinfo: "会员权益",
    strategyName: "权益名称",
  },

  // 票种管理
  ticketKind: {
    addTicketKind: "新增票种",
    ticketKindInfo: "票种信息",
    isAllDay: "是否全天通用",
  },

  // 场次
  ShowTime: {
    add: "新建场次",
    importVerifiedDetail: "导入已核验票明细",
    sessionValidity: "场次有效期",
    ticketValidity: "售票有效期",
    totalCount: "总票数(张)",
    salesCount: "已售票数(张)",
    showtimeCode: "场次编码",
    lshowtimeCode: "请输入场次编码",
    showTime: "场次时间",
    salesTime: "售票时间",
    showtimeName: "场次名称",
    showtimeType: "场次票校验类型",
    singleTicketCount: "独享库存数（张）",
    selledSharedCount: "已售共享库存数（张）",
    soldSingleTicketCount: "已售独享库存数（张）",
    relatedTicketKind: "关联票种",
    hasLimitStockTicketKind: "是否存在限制库存票种",
    limitStockTicketKind: "限制票种剩余可售",
  },

  User: {
    headerUrl: "头像",
    RegistrationDate: "注册时间",
    gender: "性别",
    channelName: "来源渠道",
    canCheck: "核验权限",
    blacklist: "拉黑",
    recover: "恢复",
    cancaelpermission: "取消核验权限",
    settingpermission: "设置核验权限",
    cardInfo: "购票人信息",
    cardNumber: "身份证号",
    userInfo: "用户信息",
    channelId: "来源渠道ID",
  },

  // 订单
  Order: {
    orderPrice: "订单金额(元)",
    actualAmount: "实收金额(元)",
    payWay: "支付方式",
    orderInfo: "订单信息",
    strategyId: "价格策略ID",
    vName: "场馆名称",
    buyTicker: "购票人",
    buyTickerInfo: "购票人信息",
    ticketCount: "套票数",
    seatCount: "座位数",
    taobaoToken: "淘宝token",
    payEndTime: "支付结束时间",
    payTime: "支付时间",
    payId: "支付ID",
    changeTime: "更新时间",
    chargeBackInfo: "退款信息",
    chargeBackStatus: "退单状态",
    chargeBackTime: "退单时间",
    Eticket: "电子票",
    ticketID: "票ID",
    ticketCode: "票编码",
    orderId: "订单ID",
    orderStatus: "订单状态",
    payStatus: "支付状态",
    sorderId: "请输入订单ID",
    suserId: "请输入用户名ID",
    sorderStatus: "请选择订单状态",
    spayStatus: "请选择支付状态",
    electronicticket: "电子票",
    refund: "退款",
    chargeBackReson: "退款原因",
    lChargeBackReson: "请输入退款原因",
    amount: "实际支付金额：",
    externalOrderId: "第三方订单ID",
    verification: "核销",
    type: "核销类型",
    encryptCode: "票号",
    code: "取票码",
    parentOrderId: "团体订单ID",
    corderId: "中台订单ID",
    returnOrder: "退单",
    contactUser: "联系人",
    contactMobile: "联系电话",
    contactUserPlaceholder: "请输入联系人",
    contactMobilePlaceholder: "请输入联系电话",
    orderCount: "张数",
  },

  // 票
  Ticket: {
    ticketconfigadd: "新建配置",
    sshowtime: "请输入场次ID",
    sconfig: "请输入配置ID",
    configName: "配置别名",
    configdetail: "票配置详情",
    ticketdetail: "票明细详情",
  },

  // 权限管理
  Auth: {
    useradd: "新增用户",
    permiss: "关联权限",
    email: "账号",
    manageuserId: "用户ID",
    realName: "用户",
    user: "用户",
    password: "密码",
    navigationName: "权限名称",
    navigationId: "权限ID",
  },

  // 价格策略
  Discount: {
    sshowTimeId: "请选择场次",
    scouponType: "请选择优惠类型",
    couponType: "优惠类型",
    discountadd: "新增价格策略",
    strategyId: "策略ID",
    rangeTime: "优惠有效期",
    couponPrice: "优惠价格(元)",
    couponTicketCount: "优惠票数(张)",
    perUserMaxTicket: "最大购买票数(张)",
    discountdetail: "价格策略详情",
    srangeTime: "请选择优惠有效期",
    discount: "价格策略",
  },

  // 推荐位
  Banner: {
    addbanner: "新建推荐位",
    bannerId: "推荐位ID",
    location: "推荐位置",
    linkUrl: "跳转链接",
    llinkUrl: "请输入跳转链接",
    img: "图片",
    bannerType: "推荐类型",
    lbannerType: "请选择推荐类型",
  },

  // 兑换码
  Activation: {
    goodsId: "兑换码ID",
    createTime: "分发时间",
    goodsName: "兑换码名称",
    bindTypeText: "绑定类型",
    count: "兑换码数量(张)",
    user: "负责人",
    addCode: "新建兑换码",
    lgoodsName: "请输入兑换码名称",
    bindType: "绑定类型",
    lbindType: "请选择绑定类型",
    ldate: "请选择日期",
    date: "选择日期",
    validDays: "有效天数(天)",
    all: "全部",
    edate1: "开始时间必须大于当前时间",
    edate2: "开始时间与结束时间不能为同一时间",
    time: "有效时间",
    discount: "价格策略",
  },

  // 淘宝
  Taobao: {
    addTaobao: "新增关联",
    taobaoItemId: "淘宝ID",
    taobaoTicketKindName: "淘宝票种名称",
    showtimeId: "场次",
    performanceName: "演出",
    ticketKindName: "票种",
    detailtitle: "淘宝商品详情",
    performanceId: "演出ID",
    ticketKindId: "票种ID",
    itemType: "出售模式",
  },

  TicketKind: {
    ticketKindId: "票种ID",
    ticketKindName: "票种名称",
    ticketKindType: "票种类型",
    minTicketPerTime: "单人最小购买量（套）",
    maxTicketPerTime: "单人最大购买量（套）",
    limitStock: "是否限制票种库存",
    usedTicketCount: "票种已用库存数",
    chanelSettlePrice: "渠道结算价",
    chanelSettlePrices: "渠道结算价（元）",
    currencyNote: "币种",
  },

  // 报表
  Report: {
    daily: "日",
    week: "周",
    month: "月",
    year: "年",
    time: "时间",
    startmonth: "起始月",
    endmonth: "结束月",
    startday: "开始日期",
    endday: "结束日期",
    totalSoldTicketCount: "总已售套票数(套)",
    totalSoldSeatCount: "总已售座位数(个)",
    totalTransCount: "总已售订单数(单)",
    totalSales: "总已售金额(元)",
    totalAllotment: "总票量(张)",
    totalSeatSoldPercent: "总已售座位数百分比",
    soldTicketCount: "已售套票数(套)",
    soldSeatCount: "已售座位数(个)",
    soldSeatPercent: "已售座位数百分比",
    transCount: "交易订单数(单)",
    transPercent: "交易订单数百分比",
    sales: "已售金额(元)",
    allotment: "总票量(张)",
    settleTime: "统计日期",
    totalIssue: "总已售座位数(个)	",
    totalTicketCount: "总已售套票数(套)",
    totalIssuePercent: "总已售座位数百分比",
    totalAvail: "总剩余可售座位数",
    totalAvailPercent: "总剩余可售座位数百分比",
    totalTicketSold: "总已售套票数(套)",
    totalSeatSold: "总已售座位数(个)",
    TotalSeatSoldPercent: "总已售座位数百分比	",
    totalTicketSales: "总已售金额(元)",
    ticketSales: "已售金额(元)",
    seatSoldPercent: "已售座位数百分比",
    seatSold: "已售座位数(个)",
    ticketSold: "已售套票数(套)",
    selectYear: "选择年",
    selectMonth: "选择月",
    selectWeek: "选择周",
    slectDay: "选择天",
  },

  // 面包屑
  shboardenues: "场馆管理",
  rformance: "演出管理",
  annelanagement: "渠道管理",
  cketind: "票种管理",
  owtimeanagement: "场次管理",
  eranagement: "用户管理",
  deranagement: "订单管理",
  cket: "票管理",
  cketanagement: "票明细",
  cketonfig: "票配置",
  ttletatistic: "报表管理",
  th: "权限管理",
  thser: "用户列表",
  thist: "权限列表",
  nagementiscount: "价格策略",
  nner: "推荐位管理",
  tivationode: "兑换码",
  obao: "淘宝商品关联",
  shboardenuesdit: "编辑场馆",
  rformanceanagement: "演出列表",
  rformanceetail: "演出详情",
  rformancedd: "新增演出",
  annelanagementdit: "编辑演出",
  rformanceecommend: "演出推荐",
  annelanagementdd: "新增渠道",
  cketinddd: "新增票种",
  cketinddit: "编辑票种",
  cketindetail: "票种详情",
  owtimeanagementdit: "编辑场次",
  owtimeanagementetail: "场次详情",
  eranagementard: "身份证信息",
  eranagementetail: "用户详情",
  deranagementetail: "订单详情",
  deranagementticket: "电子票",
  deranagementticketetail: "电子票详情",
  cketetail: "票详情",
  cketonfigdit: "编辑票配置",
  cketonfigetail: "票配置详情",
  nagementiscountetail: "价格策略详情",
  nnerdit: "编辑推荐位",
  tivationodeetail: "兑换码详情",
  obaoetail: "淘宝关联商品详情",
  port: "报表管理",
  porthannel: "渠道统计",
  porticketkind: "票种统计",
  portaytype: "支付方式统计",
  portales: "渠道销售统计",
  home: "首页",
  tivationodedit: "新建兑换码",
  showtimenew: "场次新增",
  showtimeedit: "场次编辑",
  performanceedit: "演出编辑",
  performancenew: "演出新增",
  rformancediticketKind: "演出票种",
  owtimeanagementditicketKind: "场次票种",
  owtimeanagementetailicketKind: "演出票种",
  annelontractdd: "编辑联系人",
  erinfoetail: "会员权益详情",
  erinfo: "会员权益",
  porthowtime: "场次统计",
  owtimeicketKindDetail: "场次票种列表",
  derreateStepOne: "下单",
  derreateStepTwo: "下单",
  derreateStepThree: "下单",
  der: "订单",
  deretailist: "零售订单",
  derroupist: "团体订单",
  derrderEticketList: "零售电子票列表",
  deranagementetailticketetail: "零售电子票详情",
  rformanceist: "演出列表",
  deranagementetailticket: '零售电子票列表',
  deranagementroupticket: '团体电子票列表',
  deranagementroupticketetail: '团体电子票详情',
  acerder: '下单'
};
